import { useState } from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../components/Animations';
import { McIcon } from '../components/CraftingGrid';
import { useSearchParams, Link } from 'react-router-dom';
import './WikiItemList.css';
import './WikiBlockList.css';

const VIDEO = 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/background_vids/vid_1.mp4';

function itemMaterial(item) {
  return item?.material || item?.type || 'barrier';
}

export default function WikiBlockList({ blocks = [], items = [] }) {
  const [searchParams] = useSearchParams();
  const [expanded, setExpanded] = useState(null);
  const q = (searchParams.get('q') || '').toLowerCase().trim();

  const enabledBlocks = blocks.filter(b => b.enabled !== 0 && b.enabled !== '0');
  const filtered = q
    ? enabledBlocks.filter(b =>
        b.name?.toLowerCase().includes(q) ||
        b.slug?.toLowerCase().includes(q) ||
        b.description?.toLowerCase().includes(q)
      )
    : enabledBlocks;

  const itemMap = {};
  for (const item of items) {
    if (item.name) itemMap[item.name.toLowerCase()] = item;
    if (item.slug) itemMap[item.slug.toLowerCase()] = item;
  }

  return (
    <div>
      <div className="wil-hero">
        <video className="wil-hero-vid" src={VIDEO} autoPlay muted loop playsInline />
        <div className="wil-hero-overlay" />
        <FadeIn y={30} duration={0.8} className="wil-hero-content container">
          <h1 className="wil-hero-title">Browse <em>Blocks</em></h1>
          <p className="wil-hero-sub">Discover what each block drops on SimpleMC</p>
        </FadeIn>
      </div>

      <div className="container wiki-block-page">
        {filtered.length === 0 ? (
          <div className="wiki-block-empty">
            {q ? `No blocks found for "${q}".` : 'No blocks listed yet.'}
          </div>
        ) : (
          <StaggerContainer className="wiki-block-grid">
            {filtered.map(b => {
              const isOpen = expanded === b.slug;
              return (
                <StaggerItem key={b.slug}>
                  <div
                    className={`wiki-block-card${isOpen ? ' open' : ''}`}
                    onClick={() => setExpanded(isOpen ? null : b.slug)}
                  >
                    <div className="wiki-block-card-header">
                      <div className="wiki-block-icon">
                        <McIcon materialKey={b.material || 'stone'} size={36} />
                      </div>
                      <div className="wiki-block-meta">
                        <span className="wiki-block-name">{b.name}</span>
                        {b.description && (
                          <span className="wiki-block-desc">{b.description}</span>
                        )}
                      </div>
                      <div className="wiki-block-right">
                        <span className="wiki-block-drop-count">{b.drops?.length ?? 0} drop{b.drops?.length !== 1 ? 's' : ''}</span>
                        <span className={`wiki-block-chevron${isOpen ? ' open' : ''}`}>▾</span>
                      </div>
                    </div>

                    {isOpen && (
                      <div className="wiki-block-drops" onClick={e => e.stopPropagation()}>
                        {!b.drops?.length ? (
                          <p className="wiki-block-no-drops">No custom drops listed.</p>
                        ) : b.drops.map((drop, i) => {
                          const linked = itemMap[drop.item_name?.toLowerCase()];
                          const hasAmount = drop.min_amount != null && drop.max_amount != null;
                          const amountStr = hasAmount
                            ? (drop.min_amount === drop.max_amount ? `${drop.min_amount}x` : `${drop.min_amount}–${drop.max_amount}x`)
                            : null;
                          return (
                            <div key={i} className="wiki-block-drop-row">
                              <div className="wiki-block-drop-icon">
                                {linked
                                  ? <McIcon materialKey={itemMaterial(linked)} size={22} />
                                  : <span className="wiki-block-drop-fallback">📦</span>
                                }
                              </div>
                              {linked ? (
                                <Link to={`/wiki/item/${linked.slug}`} className="wiki-obtain-mob-link" style={{ fontSize: 'var(--t-sm)' }}>
                                  {drop.item_name}
                                </Link>
                              ) : (
                                <span className="wiki-block-drop-name">{drop.item_name}</span>
                              )}
                              {amountStr && <span className="wiki-block-drop-amount">{amountStr}</span>}
                              {drop.chance && <span className="wiki-block-drop-chance">{drop.chance}</span>}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </StaggerItem>
              );
            })}
          </StaggerContainer>
        )}
      </div>
    </div>
  );
}
